import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import MultiSelectBox from '../../../../features/components/Form/MultiSelectBox'

import { targetingTypes } from '../../../DV360/LineItemForms/LineItemDv360Create/fields'
import { selectedDV360AdAccountSelector } from '../../../../modules/selectors/adAccounts'

import { searchDv360TargetingOptions } from '../../../../modules/actions/dv360Constants'
import {
  searchDv360TargetingOptionsIsLoadingSelector,
  searchDv360TargetingOptionsSelector
} from '../../../../modules/selectors/dv360Constants'

const DV360GeolocationRegion = ({ name, value, setFieldValue }) => {
  const dispatch = useDispatch()

  const searchTargetingOptionsResults = useSelector(searchDv360TargetingOptionsSelector)
  const searchTargetingOptionsIsLoading = useSelector(searchDv360TargetingOptionsIsLoadingSelector)

  const formattedGeolocations = useMemo(
    () =>
      searchTargetingOptionsResults
        // We also have countries in `targetingOptions` endpoint, so wee need to filter them out for  DV360Regions component
        .filter(item => item.geo_region_details.geo_region_type !== 'GEO_REGION_TYPE_COUNTRY')
        .map(item => ({
          label: item.geo_region_details.name,
          value: item.id
        })),
    [searchTargetingOptionsResults]
  )

  const { id: selectedAdAccountId } = useSelector(selectedDV360AdAccountSelector)

  const getGeolocations = useCallback(
    searchValue => {
      if (searchValue) {
        dispatch(
          searchDv360TargetingOptions({
            account: selectedAdAccountId,
            targeting_type: targetingTypes.TARGETING_TYPE_GEO_REGION,
            search_terms: searchValue
          })
        )
      }
    },
    [dispatch, selectedAdAccountId]
  )

  return (
    <MultiSelectBox
      name={name}
      options={formattedGeolocations}
      value={value}
      isLoading={searchTargetingOptionsIsLoading}
      setFieldValue={setFieldValue}
      onSearch={getGeolocations}
    />
  )
}

export default DV360GeolocationRegion
